import { render, staticRenderFns } from "./CircleSenderComp.vue?vue&type=template&id=fd68f98a&"
import script from "./CircleSenderComp.vue?vue&type=script&lang=js&"
export * from "./CircleSenderComp.vue?vue&type=script&lang=js&"
import style0 from "./CircleSenderComp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports